import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import STopMenu from "../../../components/student/topmenu/topmenu";
import {
  getStudentIdData,
  getStudentIdDataWithStatus,
} from "../../../lib/taskmanageview";

import { useAuth } from "../../../usercontext";
import S911TopMenu from "../../student911/topmenu/topmenu";
import S12TopMenu from "../../student12/topmenu/topmenu";
import GlobalStudentTask from "../../pages/common/globalstudenttask";
import GlobalCheckList from "../../pages/common/globalchecklist";
import PageNotes from '../../pages/common/pagenotesnew'

export default function StudentTaskList() {
	const [tasklist, setTasklist] = useState([])
	const [modal, setModal] = useState(false)
	// 1 : All , 2 : Current ,3:Later  4 : Closed
	const [tab, setTab] = useState(2)
	const [collapseOpenClose, setCollapseOpenClose] = useState(false)
	const { profile } = useAuth()

	//console.log("Task",profile);
	const toggleTab = (id) => {
		setTab(id)
	}

	const collapseAll = () => {
		setCollapseOpenClose(!collapseOpenClose)
	}

	const slug = profile.id

	async function GetData() {
		let tasks
		if (tab === 1)
			//All
			tasks = await getStudentIdData(profile.id)
		if (tab === 2)
			//Current
			tasks = await getStudentIdDataWithStatus(profile.id, 'Current')
		if (tab === 3)
			//Later
			tasks = await getStudentIdDataWithStatus(profile.id, 'Later')
		if (tab === 4)
			//Closed
			tasks = await getStudentIdDataWithStatus(profile.id, 'Closed')

		setTasklist(tasks)
	}

	useEffect(() => {
		GetData()
		//setTab(2);
	}, [tab])

	const isStudent911 = profile?.role === 'Student911'
	const isStudent12 = profile?.role === 'Student12'
	const isStudent = profile?.role === 'Student'
	return (
		<>
			{isStudent && <STopMenu slug={slug} activeMenu="Task" />}
			{isStudent911 && <S911TopMenu slug={slug} activeMenu="Agenda" />}
			{isStudent12 && <S12TopMenu slug={slug} activeMenu="Agenda" />}
			<PageNotes type={'Student'} studentId={slug} />
			{/* <div className="col-12">
        <div className="settings-widget profile-details"> */}
			<div className="settings-inner-blk p-2">
				<GlobalStudentTask studentId={slug} type={226} />
				{isStudent12 && <GlobalCheckList slug={slug} isStudent={true} />}
				<div className="settings-widget profile-details">
					<div className="profile-heading p-2">
						<h3 className="px-3">
							Agenda
							<button
								type="button"
								className="btn btn-outline-info mx-2"
								data-bs-toggle="collapse"
								data-bs-target="#collapseAgenda"
								aria-expanded="true"
								aria-controls="collapseAgenda"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="15"
									height="15"
									fill="currentColor"
									className="bi bi-chevron-double-down"
									viewBox="0 0 16 16"
								>
									<path
										fillRule="evenodd"
										d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
									/>
									<path
										fillRule="evenodd"
										d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
									/>
								</svg>
							</button>
						</h3>
					</div>
					<div className="p2 collapse show" id="collapseAgenda">
						<div className="comman-space pb-0">
							<div className="category-tab tickets-tab-blk">
								<div className="row mb-4 align-items-center h-100">
									<div className="col text-end">
										<ul className="nav nav-justified ">
											<li className="nav-item" style={{ flexBasis: 'auto' }}>
												<Link
													//to="#all"
													className={tab === 1 ? 'nav-link active' : 'nav-link'}
													//data-bs-toggle="tab"
													onClick={(e) => {
														e.preventDefault()
														toggleTab(1)
													}}
												>
													All
												</Link>
											</li>
											<li className="nav-item" style={{ flexBasis: 'auto' }}>
												<Link
													//to="#open"
													className={tab === 2 ? 'nav-link active' : 'nav-link'}
													//data-bs-toggle="tab"
													onClick={(e) => {
														e.preventDefault()
														toggleTab(2)
													}}
												>
													Agenda-1
												</Link>
											</li>
											<li className="nav-item" style={{ flexBasis: 'auto' }}>
												<Link
													//to="#open"
													className={tab === 3 ? 'nav-link active' : 'nav-link'}
													//data-bs-toggle="tab"
													onClick={(e) => {
														e.preventDefault()
														toggleTab(3)
													}}
												>
													Agenda-2
												</Link>
											</li>
											<li className="nav-item" style={{ flexBasis: 'auto' }}>
												<Link
													//to="#close"
													className={tab === 4 ? 'nav-link active' : 'nav-link'}
													//data-bs-toggle="tab"
													onClick={(e) => {
														e.preventDefault()
														toggleTab(4)
													}}
												>
													Closed
												</Link>
											</li>
										</ul>
									</div>
									<div className="col text-end">
										<button
											className="btn btn-outline-info"
											onClick={() => {
												if (collapseOpenClose) {
													setCollapseOpenClose(false)
												} else {
													setCollapseOpenClose(true)
												}
											}}
										>
											{collapseOpenClose ? (
												<>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="18"
														height="18"
														fill="currentColor"
														className="bi bi-chevron-double-up me-1"
														viewBox="0 0 16 16"
													>
														<path
															fillRule="evenodd"
															d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
														/>
														<path
															fillRule="evenodd"
															d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
														/>
													</svg>{' '}
													Collapse All
												</>
											) : (
												<>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="18"
														height="18"
														fill="currentColor"
														className="bi bi-chevron-double-down me-1"
														viewBox="0 0 16 16"
													>
														<path
															fillRule="evenodd"
															d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
														/>
														<path
															fillRule="evenodd"
															d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
														/>
													</svg>{' '}
													Expand All
												</>
											)}
										</button>
									</div>
								</div>
							</div>
							<div className="settings-invoice-blk table-responsive">
								{/* Invoice info */}
								<table className="table table-hover">
									<thead>
										<tr>
											<th>Instructor</th>
											<th>Topic</th>
											<th>Status</th>
											<th>Detail</th>
										</tr>
									</thead>
									<tbody>
										{tasklist.map(function (data, ix) {
											return (
												<>
													<tr key={data.id}>
														<td>{data.instructorinfo}</td>
														<td>{data.subject}</td>
														<td>
															{' '}
															{data.statusway === 'Current' ? (
																<span className="badge info-low">Agenda-1</span>
															) : data.statusway === 'Later' ? (
																<span className="badge badge-warning">Agenda-2</span>
															) : data.statusway === 'Closed' ? (
																<span className="badge info-high">Closed</span>
															) : (
																''
															)}
														</td>
														<td>
															<a
																className="btn btn-outline-info"
																data-bs-toggle="collapse"
																href={`#collapseExample${data.id}`}
																role="button"
																aria-expanded="false"
																aria-controls={`collapseExample${data.id}`}
															>
																<svg
																	xmlns="http://www.w3.org/2000/svg"
																	width="18"
																	height="18"
																	fill="currentColor"
																	className="bi bi-chevron-double-down"
																	viewBox="0 0 16 16"
																>
																	<path
																		fillRule="evenodd"
																		d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
																	/>
																	<path
																		fillRule="evenodd"
																		d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
																	/>
																</svg>
															</a>
														</td>
													</tr>
													<tr className={`collapse ${collapseOpenClose ? 'show' : ''}`} id={`collapseExample${data.id}`} key={ix}>
														<td colSpan={3} style={{ width: 'auto', paddingLeft: '15px' }}>
															{data.desc ? parse(data.desc) : ''}
														</td>
														<td>
															{/*}
                            <div className="form-check form-switch check-on">
                              {data.status ? 
                                <input
                                className="form-check-input"
                                type="checkbox"
                                checked={data.status}
                                onChange={(e) => ChangeTaskStatus(data.id)}
                              /> : 
                              <input
                              className="form-check-input"
                              type="checkbox"
                              checked={false}
                            />
                                }
                              
                                </div>
                                */}{' '}
														</td>
													</tr>
												</>
											)
										})}
									</tbody>
								</table>
								{/* Invoice info */}
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* </div>
      </div> */}
		</>
	)
}
